import { Fragment } from 'react';
import Image from 'next/legacy/image';

import { Container, Text } from '@/atoms';
import { Faq } from '@/molecules';

/**
 * Faqs
 */
const FaqsImagen = ({ bloque, id, className }: any) => (
  <Container id={id} wrapper {...(className && { className })}>
    <Text
      as={bloque.faq[0].headingType}
      className="u-headline u-headline--h2 mb-6 text-left text-primary-900"
    >
      {bloque.faq[0].title}
    </Text>

    <div
      className={`flex items-start justify-center gap-6 lg:justify-between ${bloque.imageLocation === 'left' && 'flex-row'} ${bloque.imageLocation === 'right' && 'flex-row-reverse'}`}
    >
      <div className="hidden lg:block">
        <Image
          src={bloque.image.sourceUrl}
          alt={bloque.image.altText}
          width={bloque.image.mediaDetails.width}
          height={bloque.image.mediaDetails.height}
          layout="fixed"
        />
      </div>

      <Container
        padding="p-0"
        className="flex w-full max-w-[560px] flex-col gap-4"
      >
        {bloque.faq.map((faq: any, index: number) => (
          <Fragment key={index}>
            {faq.preguntas.map((pregunta: any, index: number) => (
              <Faq
                key={index}
                question={pregunta.question}
                headingType={pregunta.headingType}
              >
                {pregunta.answer}
              </Faq>
            ))}
          </Fragment>
        ))}
      </Container>
    </div>
  </Container>
);

FaqsImagen.displayName = 'FaqsImagen';

export default FaqsImagen;
